function isObject<T = unknown>(item: T) {
	return item && typeof item === 'object' && !Array.isArray(item);
}

function areEqual<T = unknown>(a: T, b: T) {
	if (a === b) return true;

	if (a instanceof Date && b instanceof Date) {
		return a.getTime() === b.getTime();
	}

	if (a instanceof RegExp && b instanceof RegExp) {
		return a.toString() === b.toString();
	}

	if (a instanceof Map && b instanceof Map) {
		if (a.size !== b.size) return false;
		for (const [key, value] of a) {
			if (!b.has(key) || !areEqual<T>(value, b.get(key))) return false;
		}
		return true;
	}

	if (a instanceof Set && b instanceof Set) {
		if (a.size !== b.size) return false;
		for (const value of a) {
			if (!b.has(value)) return false;
		}
		return true;
	}

	if (Array.isArray(a) && Array.isArray(b)) {
		if (a.length !== b.length) return false;
		for (let i = 0; i < a.length; i++) {
			if (!areEqual<T>(a[i], b[i])) return false;
		}
		return true;
	}

	if (isObject<T>(a) && isObject<T>(b)) {
		const keysA = Object.keys(a);
		const keysB = Object.keys(b);
		if (keysA.length !== keysB.length) return false;
		for (const key of keysA) {
			if (!keysB.includes(key) || !areEqual<T>(a[key], b[key])) return false;
		}
		return true;
	}

	return false;
}

export function getObjectDifferences<T = unknown>(oldValue: T, newValue: T): Partial<T> {
	const diff: Partial<T> = {};

	const keys = new Set([...Object.keys(oldValue), ...Object.keys(newValue)]);

	keys.forEach((key) => {
		const value1 = oldValue[key];
		const value2 = newValue[key];

		if (!areEqual<T>(value1, value2)) {
			diff[key] = value2 !== undefined ? value2 : null;
		}
	});

	return diff;
}
